<template>
  <v-dialog persistent v-model="basicEducationExtensionModalVisible" max-width="310px">
    <v-card flat>
      <v-icon class="close" @click.prevent="$emit('close')">$sl-close</v-icon>
      <h2>{{ $t("labels.change-basic-eduction-time") }} {{ get(apprentice, 'person.firstName', '') }} {{ get(apprentice, 'person.lastName', '') }}</h2>
      <p class="pt-6">{{ $t("labels.change-basic-education-length-prescription")}}</p>
      <p class="pt-3">{{ $t("labels.change-basic-education-length")}}</p>

      <v-radio-group
        v-model="radioMonths"
        :key="radioMonths"
        column
      >
        <v-radio
          name="radio2"
          :label="getRadioText(1)"
          :value="6"
          key="2"
          :disabled="availableMonths(get(extendedEducationObj, 'distanceEducationProviderExtension.months', null), 6)"
        ></v-radio>
        <v-radio
          name="radio1"
          :label="getRadioText(0)"
          :value="3"
          key="1"
          :disabled="availableMonths(get(extendedEducationObj, 'distanceEducationProviderExtension.months', null), 3)"
        ></v-radio>
      </v-radio-group>

      <template>
        <p :style="{ height: '20px' }" class="caption" v-html="priceTextDetail"></p>
      </template>

      <div class="d-flex justify-space-between pb-2 pt-4">
        <ActionButton
            :type="'application'"
            smallerText
            :block="false"
            @click="$emit('close')"
            actionIcon="$sl-cancel"
          >{{ $t('labels.cancel') }}</ActionButton>
          <ActionButton
            :block="false"
            class=""
            smallerText
            actionIcon="$sl-save"
            @click="createEducationExtension()"
            :isDisabled="isImitatingUser()"
          >{{ $t('labels.save') }}</ActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from "@/components/Common/ActionButton";
import get from 'lodash/get'
import {mapGetters} from 'vuex'

export default {
  name: 'PersonBasicEducationTimeModal',

  components: {
    ActionButton
  },

  props: {
    apprentice: {
      type: Object,
      default: () => ({})
    },
    extendedEducationObj: {
      type: Object,
      default: () => ({})
    },
    basicEducationExtensionModalVisible: {
      type: Boolean,
      default: false
    },
  },

  data: () => ({
    months: 0,
    radioMonths: 3,
    distanceProviderExtensions: []
  }),

  computed: {
    ...mapGetters('currentuser', ['isImitatingUser']),
    availableMonths() {
      return (months, radioValue) => !!(radioValue === 6 && months === 3 || months === 6) || !!(radioValue === 3 && months === 6)
    },

    priceTextDetail() {
      const extension = this.distanceProviderExtensions?.find(ext => this.radioMonths == ext.months)
      if(extension && this.distanceProviderExtensions.length > 0) {
        return `Observera att denna förlängning kommer att innebära en kostnad på <b>${extension.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} kronor</b>.`
      }
      return ''
    },
  },

  watch: {
    extendedEducationObj: {
      handler: function(val) {
        this.radioMonths = val?.distanceEducationProviderExtension?.months === 6 ? 6 : 3
      },
    },

    basicEducationExtensionModalVisible: {
      handler: function(val) {
        if(val) {
          this.init()
        }
        this.distanceProviderExtensions = []
      }
    },
  },

  methods: {
    get: get,

    init() {
      const id = this.apprentice?.id
      if(!id) return
      API.getBook(id).then(({ data }) => {
        const { distanceEducationProviderId } = data.education?.educationDistanceEducationProviderCourses[0]?.distanceEducationProviderCourse
        API.listDistanceEducationProviderExtensions(distanceEducationProviderId).then(({ data }) => {
          this.distanceProviderExtensions = data.rows
        })
      })
    },

    createEducationExtension() {
      let apiMethod = 'createEducationExtension'

      if(Object.keys(this.extendedEducationObj).length > 0)
        apiMethod = 'updateEducationExtension'

      const months = this.radioMonths === 6 ? 6 : 3

      let data = {
        id: get(this, 'extendedEducationObj.id', null),
        educationId: this.apprentice.educationId,
        distanceEducationProviderId: this.distanceProviderExtensions[0]?.distanceEducationProviderId,
        months: this.extendedEducationObj?.distanceEducationProviderExtension?.months ? (months + this.extendedEducationObj?.distanceEducationProviderExtension?.months) : months
      }

      API[apiMethod]({ data: data }).then(response => {
        this.$events.fire('showInfo', this.$t('success.saved'))
        this.$emit('close')
      })
      .catch(error => {
        console.log('Error: ', error)
        this.$events.fire('showError', this.$t('error.save-error'))
      })
    },

    getRadioText(m){
      let ret

      if(m < 1)
        ret = this.$tc("labels.month-text", '+' + 3)
      else if(m === 1)
        ret = this.$tc("labels.month-text", '+' + 6)
      return ret
    },
  }
}
</script>
